/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetadataPropertyDto
 */
export interface MetadataPropertyDto {
    /**
     * 
     * @type {string}
     * @memberof MetadataPropertyDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MetadataPropertyDto
     */
    value?: string;
}

/**
 * Check if a given object implements the MetadataPropertyDto interface.
 */
export function instanceOfMetadataPropertyDto(value: object): value is MetadataPropertyDto {
    return true;
}

export function MetadataPropertyDtoFromJSON(json: any): MetadataPropertyDto {
    return MetadataPropertyDtoFromJSONTyped(json, false);
}

export function MetadataPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetadataPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function MetadataPropertyDtoToJSON(json: any): MetadataPropertyDto {
    return MetadataPropertyDtoToJSONTyped(json, false);
}

export function MetadataPropertyDtoToJSONTyped(value?: MetadataPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

